// @ts-nocheck





import { fetchRequest, initialFetchListParams } from './index';

import { convertFromHourToSecond, convertFromSecondToHour } from '../pure/unitConversions';
import { convertFromServer as convertOperationLimitFromServer } from './operationLimit';

const convertDataFromServer = (group) => ({
  ...group,
  hours: convertFromSecondToHour(parseFloat(group.hours)),
  hoursWeekend: convertFromSecondToHour(parseFloat(group.hoursWeekend)),
  operationLimits: group.operationLimits.map(convertOperationLimitFromServer)
});

const convertDataToServer = (group) => ({
  ...group,
  hours: convertFromHourToSecond(group.hours),
  hoursWeekend: convertFromHourToSecond(group.hoursWeekend)
});

export const addOperationLimitGroup = async (
operationLimitGroup) =>
{
  const added = await fetchRequest.post(
    '/operationLimitGroup',
    convertDataToServer(operationLimitGroup)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось добавить группу регламента для должности');
};

export const updateOperationLimitGroup = async (
operationLimitGroup) =>
{
  const updated = await fetchRequest.put(
    '/operationLimitGroup',
    convertDataToServer(operationLimitGroup)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить группу регламента для должности');
};
export const deleteOperationLimitGroup = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/operationLimitGroup/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить группу регламента для должности');
};

export const fetchOperationLimitGroup = async (
id,
params = {}) =>
{
  const operationLimitGroup = await fetchRequest.get(
    `/operationLimitGroup/${id}`,
    params
  );
  if (operationLimitGroup) return convertDataFromServer(operationLimitGroup);
  throw new Error('Не удалось получить группу регламента для должности');
};

export const fetchOperationLimitGroups = async (
params = initialFetchListParams) =>
{
  const operationLimitGroups = await fetchRequest.get('/operationLimitGroup/', {
    ...initialFetchListParams,
    ...params,
    orderBy: 'created',
    byDescending: false
  });
  if (operationLimitGroups) {
    operationLimitGroups.data = operationLimitGroups.data.map(
      convertDataFromServer
    );
    return operationLimitGroups;
  }
  throw new Error('Не удалось получить список групп регламентов для должности');
};

export default {
  addOperationLimitGroup,
  updateOperationLimitGroup,
  deleteOperationLimitGroup,
  fetchOperationLimitGroup,
  fetchOperationLimitGroups
};
